import { view } from "@risingstack/react-easy-state";
import { Accordion, Button, Grid, Group } from "@tine/designsystem-ui-react";

import type { Product } from "../../common/types/productTypes";
import { LIST_TYPE } from "../../common/types/trackingTypes";

import { IconPrint } from "@tine/designsystem-icons/sharp";
import { sendAccordionClick } from "../../common/tracking";
import WhiteSheet from "../../components/WhiteSheet";
import ProductList from "../../components/common/product/ProductList";

import ProductDescriptionAndContent from "./ProductDescriptionAndContent";
import ProductDetailsImage from "./ProductDetailsImage";
import ProductDetailsInfo from "./ProductDetailsInfo";

type ExpiredProductDetailsProps = {
   product: Product;
};

const ExpiredProductDetails = ({ product }: ExpiredProductDetailsProps) => {
   return (
      <>
         <WhiteSheet className="tw-py-12">
            <Grid cols={12} gap={{ base: 2, lg: 8 }} className="tw-relative tw-pb-6">
               <div className="tw-absolute tw-top-0 tw-right-0 tw-z-20 tw-hidden lg:tw-block">
                  <Button size="compact" onClick={() => window.print()} variant="tertiary" icon={<IconPrint />}>
                     Skriv ut produktdatablad
                  </Button>
               </div>
               <Grid.Col span={{ base: 12, lg: 4 }} className="tw-relative">
                  <ProductDetailsImage product={product} />
               </Grid.Col>

               <Grid.Col span={{ base: 12, lg: 8 }} className="tw-pb-6 tw-relative">
                  <ProductDetailsInfo product={product} />
               </Grid.Col>
            </Grid>

            <Accordion
               label="Vis produktinformasjon"
               variant="compact"
               className="tw-max-w-[1350px]"
               onClick={() => sendAccordionClick("Vis produktinformasjon (utgått produkt)")}
            >
               <div className="tw-my-6">
                  <ProductDescriptionAndContent product={product} />
               </div>
            </Accordion>
         </WhiteSheet>
         <div className="lg:tw-hidden tw-py-4">
            <Button size="compact" onClick={() => window.print()} variant="secondary" icon={<IconPrint />}>
               Skriv ut produktdatablad
            </Button>
         </div>

         <Group justify="start" className="tw-mt-6 tw-border-ink-border-subtle">
            <ProductList
               skus={product.newSkus && product.newSkus.length > 0 ? product.newSkus : product.similarProducts}
               listName="Erstatningsprodukter"
               heading={product.newSkus?.length === 1 ? "Erstattes med" : "Andre anbefalte produkter"}
               listType={LIST_TYPE.RECOMMENDATIONS}
               context="recommendations"
               count={6}
            />
         </Group>
      </>
   );
};

export default view(ExpiredProductDetails);
